import { httpApi } from "./http.api";

export const getRecruiterQuestionSets = (page: number): Promise<any> =>
    httpApi.get<any>(`/interview/question-sets/?page=${page}`).then(({ data }) => data);
